<template>
  <v-card>
    <v-container class="pt-0 pb-0">
      <v-layout>
        <v-btn id="alert-details-back-btn" aria-label="back-to-alerts" small flat class="back-btn" @click="goBack">
          <v-icon>arrow_back</v-icon>
          <span>{{description}}</span>
        </v-btn>
      </v-layout>
    </v-container>
  </v-card>
</template>
<script>
  export default {
    name: 'backto-breadcrumb',
    props: {
      description: {
        type: String,
        required: true
      }
    },
    methods: {
      goBack () {
        this.$router.push({name: 'AdminAlerts'})
      }
    }
  }
</script>
<style scoped>
  .back-btn {
    text-transform: none;
    margin-left: 0px;
    font-size: 14px;
  }

</style>



// WEBPACK FOOTER //
// src/components/settings/alert/BackBreadcrumb.vue